import SearchPage from './search';

export default SearchPage;
export { SearchPage };
